export default __webpack_public_path__ + "static/media/IMG_7713.9f1fc9aa.jpg";